import React from 'react';
import { Box } from '@mui/material';
import { CssTextField } from 'components/select';
import { useRecoilValue } from 'recoil';
import { OrderPayload } from 'pages/reference-implementation/provisioning/RI003AWS/store';

const Region = () => {
    const order = useRecoilValue(OrderPayload);
    const landingZoneDetails = order?.landingZoneDetails;

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <CssTextField
                data-testid="region-textfield"
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                label="AWS Region"
                value={landingZoneDetails?.regionDisplayName || ''}
                disabled
                fullWidth
                variant="outlined"
            />
        </Box>
    );
};

export default React.memo(Region);
